<template>
  <div class="contenedor d-flex" v-if="!isMobile">
    <div class="toolbar d-flex">
      <div class="left d-flex">
        <div
          class="d-flex align-items-center buscador"
          @click="openFilter($event.currentTarget)"
        >
          <div class="inner-buscador" v-if="!filtered">
            <p class="h3-defaultMuni">{{ placeholder }}</p>
            <img
              id="lupa"
              :src="theme === 'dark' ? icons.lupaLight : icons.lupaDark"
            />
          </div>
          <div v-else class="inner-buscador filtered">
            <p class="h3-defaultMuni">Filtros aplicados</p>
            <ThemedIcon name="close" id="lupa" @click.stop="clearFilters" />
          </div>
        </div>
        <button
          v-if="showButton && botonTexto"
          class="boton-agregar h1-defaultMuni"
          @click="emit('accion')"
        >
          {{ botonTexto }}
        </button>
        <div>
          <img
            src="@/assets/images/muni/plus-clock.svg"
            alt=""
            class="icon-clock"
            @click="abrirRecordatorio"
          />
        </div>
        <div class="d-flex opcionVistas" v-if="showViews">
          <img
            v-if="views.includes('lista')"
            :src="icons.vistaLista"
            :class="{ activo: vistaActiva === 'lista' }"
            @click="emit('cambiar-vista', 'lista')"
          />
          <img
            v-if="views.includes('tabla')"
            :src="icons.vistaTabla"
            :class="{ activo: vistaActiva === 'tabla' }"
            @click="emit('cambiar-vista', 'tabla')"
          />
        </div>
        <slot name="acciones" />
      </div>
      <div class="right d-flex" v-if="showUserOptions">
        <router-link to="/home-agentes">
          <ThemedIcon id="gov360" name="LogoGob360" />
        </router-link>
        <div class="content d-flex">
          <ThemedIcon @click="toggleTheme" name="theme" />
          <div
            style="display: flex; position: relative"
            class="bell"
            :class="{ shake: animarCampana }"
          >
            <img
              :src="
                theme === 'dark'
                  ? icons.notificacionesDark
                  : icons.notificacionesLight
              "
              @click="abrirNotificacionPanel()"
            />
            <span
              v-if="cantidadNoLeidas > 0"
              class="badge h2-defaultMuni"
              @click="abrirNotificacionPanel()"
              >{{ cantidadNoLeidas > 9 ? "9+" : cantidadNoLeidas }}</span
            >
          </div>
          <img
            :src="
              theme === 'dark'
                ? icons.cerrarSesionDark
                : icons.cerrarSesionLight
            "
            @click="abrirConfirmacionCerrarSesion"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="contenedor d-flex" v-else>
    <div class="toolbar d-flex">
      <div class="left-mobile d-flex">
        <ThemedIcon
          name="LuqueLogoMuni"
          class="logo-luque-mobile"
          @click="toggleSidebar"
        />
      </div>
      <div class="center-mobile">
        <!-- <img
          src="@/assets/images/muni/LogoGob360.svg"
          class="logo-gob360-mobile"
        /> -->
        <!-- <ThemedIcon class="logo-gob360-mobile" name="LogoGob360" /> -->
        <div
          class="loaders"
          :class="{ loading: loadingTareas, invertido: theme === 'dark' }"
          @click="!loadingTareas && emit('recargar-tareas')"
        />
        <ThemedIcon class="action" @click="openNotifications" name="IconNoti" />
      </div>
    </div>
  </div>

  <slot />
  <ModalManager ref="modalManagerRef" />
</template>

<script setup>
import NotificacionesPanel from "@/components/Municipal/Sidebar/NotificacionesPanel.vue";
import { useStore } from "vuex";
// import { useToast } from "vue-toastification";

import { ref, onMounted, onUnmounted, computed } from "vue";
import ModalManager from "@/components/Utils/Modales/ModalManager.vue";
import ModalCerrarSesion from "@/components/Municipal/Modals/ModalCerrarSesion.vue";
import FiltroComponentSimplificado from "@/components/Municipal/Filtro/FiltroComponentSimplificado.vue";
import NewReminder from "@/components/Municipal/Modals/Reminder/NewReminder.vue";
import { getNotificaciones } from "@/services/notifications/notificacionService";
import ConfirmarV2 from "../../Modals/Estados/ConfirmarV2.vue";
import IconNoti from "@/assets/images/muni/icon-notification.svg";
import { SocketOffice } from "@/services/sockets/officeSocket";
import { useNotify } from "@/components/Municipal/Composables/useNotify";
import CommunicationsService from "@/services/office/communicationsService";
import { mostrarNotificacionSistema } from "@/services/notifications/permissionService";
import { navegarDesdeNotificacion } from "@/services/helpers/notificationNavigation";
import { getTheme, toggleTheme } from "@/services/helpers/themeHelper";
import ThemedIcon from "@/components/Utils/ThemedIcon.vue";

const emit = defineEmits([
  "accion",
  "abrir-tramite",
  "abrir-turno",
  "abrir-tarea",
]);
// const toast = useToast();
const animarCampana = ref(false);
const notify = useNotify();
let lastIds = new Set();
let initialized = false;
const theme = ref(getTheme());

// const mostrarNotificaciones = ref(false);
const isMobile = ref(false);
const modalManagerRef = ref(null);
const store = useStore();
const yourLocalNotificaciones = ref([]);
const cantidadNoLeidas = ref(0);
const onThemeChange = () => {
  theme.value = getTheme();
};

const mostrarModalSinLeer = () => {
  const message = {
    one: "Tienes algunas notificaciones sin revisar",
  };
  const toModal = {
    size: "auto",
    message: message,
    icono: IconNoti,
    confirm: "Revisar",
    cancel: "Ignorar",
    onConfirm: () => {
      abrirNotificacionPanel();
      emit("close-modal", 1);
    },
    onCancel: () => {
      emit("close-modal", 1);
    },
  };
  modalManagerRef.value?.openModal(ConfirmarV2, toModal);
};

// const notificacionesPanel = ref(null);

function openFilter(element) {
  if (!element) return;

  const targetRect = element.getBoundingClientRect();
  const screenWidth = window.innerWidth;
  // 1. Ancho del modal en píxeles (basado en 39.824vw)
  const modalWidthInPixels = screenWidth * 0.39824;

  // 2. Ancho del target en píxeles
  const targetWidthInPixels = targetRect.width;

  // 3. Calculamos el offset horizontal para alinear los bordes izq
  // offsetX = (ancho_target / 2) - (ancho_modal / 2)
  const calculatedOffsetX = (targetWidthInPixels - modalWidthInPixels) / 2;
  const calculatedOffsetY = 13;

  const toModal = {
    size: "auto",
    scrollable: false,
    target: element,
    opacity: 0,
    position: "bottom",
    offsetY: calculatedOffsetY,
    offsetX: -calculatedOffsetX, // Usamos el valor calculado
  };

  modalManagerRef.value?.openModal(FiltroComponentSimplificado, toModal);
}

// --- GESTIÓN DE MODALES ---
const openFirstModal = (modal, modalProps) => {
  if (modalManagerRef.value) {
    modalManagerRef.value.openModal(modal, modalProps);
  }
};

const openNotifications = () => {
  openFirstModal(NotificacionesPanel, {
    size: "auto",
    scrollable: false,
    position: "bottom",
    draggable: true,
    dragDismiss: {
      enabled: true,
      minThresholdPx: 72,
      minVelocity: 0.45,
    },
  });
};

function abrirRecordatorio() {
  modalManagerRef.value?.openModal(NewReminder, {
    size: "auto",
    scrollable: false,
  });
}

function abrirConfirmacionCerrarSesion() {
  modalManagerRef.value?.openModal(ModalCerrarSesion, {
    size: "auto",
    scrollable: false,
    noClose: true,
  });
}

function abrirNotificacionPanel() {
  modalManagerRef.value?.openModal(NotificacionesPanel, {
    size: "auto",
    scrollable: false,
    draggable: true,
    dragDismiss: {
      enabled: true,
      minThresholdPx: 72,
      minVelocity: 0.45,
    },
    position: window.innerWidth > 768 ? "right" : "bottom",
    openFromNoti: onAbrirDesdeNoti,
    // borderRadius: "1rem 0 0 1rem",
  });
}

const checkMobile = () => {
  isMobile.value = window.innerWidth <= 770;
};
onMounted(() => {
  window.addEventListener("theme-change", () => {
    console.log("theme changed!", getTheme());
    theme.value = getTheme();
  });
  window.addEventListener("resize", checkMobile);
  checkMobile();

  if (!store.state.loggedIn || !store.state.user?.id) return;

  checkNotis();

  SocketOffice?.on(`communications:update:${store.state.user.id}`, checkNotis);
});
const checkNotis = async () => {
  if (!store.state.loggedIn || !store.state.user?.id) return;

  const prevUnread = cantidadNoLeidas.value;

  const { notificaciones, notRead } = await getNotificaciones();

  if (!initialized) {
    lastIds = new Set(notificaciones.map((n) => n.id));
    initialized = true;

    yourLocalNotificaciones.value = notificaciones;
    cantidadNoLeidas.value = notRead;

    return;
  }

  // DESPUÉS → NOTIFICA SOLO NUEVAS
  notificaciones.forEach((n) => {
    const isNew = !lastIds.has(n.id);
    const isTabVisible = document.visibilityState === "visible";

    if (isNew && !n.read) {
      if (isTabVisible) {
        notify.info(n.subject || "Nueva notificación", {
          title: "Nueva comunicación",
          duration: 5000,
          actions: [
            {
              label: "Ver",
              variant: "primary",
              onClick: () => abrirDesdeNotificacion(n),
            },
          ],
        });
      } else {
        mostrarNotificacionSistema(n);
      }
    }
  });
  // actualizar sets y estados
  lastIds = new Set(notificaciones.map((n) => n.id));
  yourLocalNotificaciones.value = notificaciones;
  cantidadNoLeidas.value = notRead;

  // campana si subió
  if (notRead > prevUnread) {
    animarCampana.value = true;
    setTimeout(() => (animarCampana.value = false), 600);
  }

  // modal sin leer (una vez)
  const yaMostroModal = store.state?.modalUnreadSeen;
  if (notRead > 0 && !yaMostroModal) {
    mostrarModalSinLeer();
    store.dispatch("setModalUnreadSeenAction", true);
  }
};

async function abrirDesdeNotificacion(item) {
  if (!item.read) {
    const resp = await CommunicationsService.markAsRead([item.id]);
    if (resp?.success) {
      item.read = true;
      cantidadNoLeidas.value = yourLocalNotificaciones.value.filter(
        (n) => !n.read,
      ).length;
    }
  }

  navegarDesdeNotificacion(item);
}
onUnmounted(() => {
  window.removeEventListener("resize", checkMobile);
  window.removeEventListener("theme-change", onThemeChange);

  if (store.state.user?.id) {
    SocketOffice?.off(
      `communications:update:${store.state.user.id}`,
      checkNotis,
    );
  }
});
function toggleSidebar() {
  store.dispatch("toggleSidebar");
}

defineProps({
  botonTexto: { type: String, required: false },
  placeholder: { type: String, default: "Búsqueda y filtros" },
  showViews: { type: Boolean, default: false },
  showUserOptions: { type: Boolean, default: true },
  showButton: { type: Boolean, default: true },
  views: {
    type: Array,
    default: () => ["tabla", "cards", "miniCards", "none"],
  },
  icons: {
    type: Object,
    required: true,
  },
  vistaActiva: { type: String, default: "tabla" },
  loadingTareas: Boolean,
});

function onAbrirDesdeNoti({ tipo, id }) {
  if (tipo === "tramite") {
    emit("abrir-tramite", id);
  } else if (tipo === "turno") {
    emit("abrir-turno", id);
  } else if (tipo === "tarea") {
    emit("abrir-tarea", id);
  }
}

const filtered = computed(() => {
  const filters = store.state.filters;
  return Object.values(filters).some((filterGroup) => {
    return filterGroup && Object.keys(filterGroup).length > 0;
  });
});

const clearFilters = () => {
  const sections = Object.keys(store.state.filters || {});
  sections.forEach((section) => {
    store.dispatch("clearFiltersAction", section);
  });
};
</script>

<style scoped>
.contenedor {
  margin: 3.339dvh 0px 5.008dvh 0px;
  align-items: center;
}

.toolbar {
  position: relative;
  height: 6.678dvh;
  align-items: center;
  justify-content: space-between;
  width: 82.03vw;
}

.toolbar .left {
  display: flex;
  gap: 1.757vw;
  align-items: center;
}

.toolbar .right {
  display: flex;
  justify-content: space-between;
  width: 19.034vw;
  align-items: center;
}

.right img {
  cursor: pointer;
}

.right .content {
  display: flex;
  gap: 0.366vw;
}

#gov360 {
  width: 8.573vw;
}

#lupa {
  width: 1.025vw;
  height: 2.337dvh;
}

.content img {
  width: 2.928vw;
  height: 6.678dvh;
}

.buscador {
  /* padding: 1.669dvh 1.464vw; */
  border-radius: 0.5rem;
  border: 1px solid var(--gray-version);
  background: var(--gray-version);
  width: 19.034vw;
  height: 6.678dvh;
  justify-content: space-between;
  cursor: pointer;
}

.inner-buscador {
  display: flex;
  width: 100%;
  justify-content: space-between;
  /* margin: 1.669dvh 1.464vw; */
  margin: 0px 0.73vw;
  padding: 0vh 0.73vw;
  align-items: center;
}

.inner-buscador.filtered {
  border-radius: 0.5rem;
  padding: 0.5vh 0.73vw;
  background-color: var(--secondary-muni, #a4cbc6);
}

.filtered #lupa {
  width: 0.73vw;
}

.opcionVistas {
  gap: 0.732vw;
}

.opcionVistas img {
  cursor: pointer;
  width: 2.196vw;
  height: 5.008dvh;
}

.boton-agregar {
  background: none;
  border: 1px solid #00b398;
  min-width: 12.079vw;
  padding: 1.669dvh 0.732vw;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 6.678dvh;
  border-radius: 0.5rem;
  color: #00b398;
  cursor: pointer;

  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.boton-agregar:hover {
  transform: translateY(-1px);
}

.boton-agregar:active {
  transform: scale(0.97);
}

.badge {
  cursor: pointer;
  border: 0.18vw solid var(--bg-popup);
  background-color: red;
  color: var(--blanco);
  border-radius: 50%;
  width: 1.9vw;
  height: 1.9vw;
  /* aspect-ratio: 1 / 1; */
  position: absolute;
  top: -20%;
  right: -20%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.opcionVistas img.activo {
  filter: brightness(0) saturate(100%) invert(54%) sepia(88%) saturate(300%)
    hue-rotate(115deg) brightness(95%) contrast(100%);
}

.left-mobile {
  display: flex;
  flex-grow: 0;
}

.center-mobile {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-items: center;
  gap: 15px;
  justify-content: flex-end;
}

.logo-luque-mobile {
  width: 125px;
  height: 38px;
  object-fit: cover;
}

.logo-gob360-mobile {
  width: 29.44vw;
}

.icon-clock {
  height: 2.17vw;
  cursor: pointer;
}

.toolbar img,
.icon-clock,
.icon {
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;
}

.toolbar img:hover,
.icon-clock:hover,
.icon:hover .bell:hover {
  transform: scale(1.08);
  opacity: 0.9;
}

.shake {
  animation: shakeBell 0.6s;
}

@keyframes shakeBell {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(10deg);
  }

  50% {
    transform: rotate(-10deg);
  }

  75% {
    transform: rotate(6deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

.toolbar img:active,
.icon-clock:active,
.icon:active {
  transform: scale(0.95);
}

@media (min-width: 1440px) {
  .contenedor {
    justify-content: center;
    margin: 20px 0px 30px 0px;
    width: 100%;
  }

  .toolbar {
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .contenedor {
    justify-content: center;
    width: 100%;
    margin: unset;
  }

  .toolbar {
    width: 100%;
    height: auto;
    align-items: flex-end;
  }

  .toggleBtn {
    width: 6.93vw;
  }
  .loaders {
    width: 24px;
    height: 24px;
    display: inline-block;
    position: relative;
    box-sizing: border-box;
    cursor: pointer;
    border: 2px solid;
    border-color: var(--text-primary) transparent var(--text-primary)
      transparent;
    border-radius: 50%;
    transition: transform 0.2s ease;
  }

  .loaders.loading {
    animation: rotate 0.8s cubic-bezier(0.4, 0, 0.2, 1) infinite;
    transition: none;
    cursor: default;
    margin: unset;
  }
  /* pseudo elementos */
  .loaders::before,
  .loaders::after {
    content: "";
    position: absolute;
    border: 4px solid transparent;
  }

  /* flecha blanca */
  .loaders::before {
    border-bottom-color: var(--text-primary);
    transform: translate(-4px, 10px) rotate(-35deg);
  }

  /* flecha naranja */
  .loaders::after {
    border-color: var(--text-primary) transparent transparent transparent;
    transform: translate(14px, 1px) rotate(-35deg);
  }

  /* dark mode */
  .loaders.invertido {
    border-color: var(--text-primary) transparent var(--text-primary)
      transparent;
  }

  .loaders.invertido::before {
    border-bottom-color: var(--text-primary);
  }

  .loaders.invertido::after {
    border-color: var(--text-primary) transparent transparent transparent;
  }

  /* click */
  .loaders:not(.loading):active {
    transform: scale(0.9);
  }

  /* animación */
  @keyframes rotate {
    to {
      transform: rotate(1turn);
    }
  }
}
</style>
